import { createFileRoute } from '@tanstack/react-router'
import { ArrangementList } from '@/features/sil/arrangement-list'

export const Route = createFileRoute(
  '/_authenticated/_organization/scheduler/sil/'
)({
  component: ArrangementList,
})
